import client from './client';

export interface ReportSummary {
  totalWaitings: number;
  totalSeated: number;
  totalNoShow: number;
  totalCancelled: number;
  averagePartySize: number;
  noShowRate: number;
  cancelRate: number;
  averageDailyWaitings: number;
  newCustomers?: number;
  returningCustomers?: number;
  newVisits?: number;
  returningVisits?: number;
  returningRate?: number;
}

export interface DailyReport {
  date: string;
  total: number;
  seated: number;
  noShow: number;
  cancelled: number;
  active: number;
}

export interface HourlyReport {
  hour: number;
  count: number;
}

export interface WeeklyReport {
  dayOfWeek: number;
  dayName: string;
  totalWaitings: number;
  dayCount: number;
  average: number;
}

export interface MonthlyReport {
  month: number;
  totalWaitings: number;
  noShowRate: number;
  averagePartySize: number;
}

export async function getSummary(
  storeId: string,
  from: string,
  to: string,
): Promise<ReportSummary> {
  const res = await client.get(`/api/reports/${storeId}/summary`, {
    params: { from, to },
  });
  return res.data;
}

export async function getDaily(
  storeId: string,
  from: string,
  to: string,
): Promise<DailyReport[]> {
  const res = await client.get(`/api/reports/${storeId}/daily`, {
    params: { from, to },
  });
  return res.data;
}

export async function getHourly(
  storeId: string,
  date: string,
): Promise<HourlyReport[]> {
  const res = await client.get(`/api/reports/${storeId}/hourly`, {
    params: { date },
  });
  return res.data;
}

export async function getWeekly(
  storeId: string,
  from: string,
  to: string,
): Promise<WeeklyReport[]> {
  const res = await client.get(`/api/reports/${storeId}/weekly`, {
    params: { from, to },
  });
  return res.data;
}

export async function getMonthly(
  storeId: string,
  year: number,
): Promise<MonthlyReport[]> {
  const res = await client.get(`/api/reports/${storeId}/monthly`, {
    params: { year },
  });
  return res.data;
}
